import { FC } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Util from '../../../../misc/util';
import { Button } from '../../atomic/button';
import { CardApprovalRequest } from '../../../../queries/pxtraCard';
import { sumCost } from './utils';

type Props = {
  selected: CardApprovalRequest[];
  canApprove: boolean;
  onApprove: () => void;
  onReject: () => void;
};

/** 2.4 AK 7a: without the cost of the selection, bulk approval is not allowed. */
export const ApprovalSelectionSummary: FC<Props> = ({
  selected,
  canApprove,
  onApprove,
  onReject
}) => {
  const { t } = useTranslation();
  const cost = sumCost(selected);

  return (
    <Box className="flex items-center gap-6 bg-grey-50 rounded-xl px-4 py-3 mb-3">
      <Box>
        <Typography variant="caption" color="grey.600">
          {t('pxtraCard:sumOneOff')}
        </Typography>
        <Typography variant="subtitle1" className="font-medium">
          {Util.formatCurrency(cost.one_off_cents)}
        </Typography>
      </Box>
      <Divider orientation="vertical" flexItem className="border-grey-100" />
      <Box>
        <Typography variant="caption" color="grey.600">
          {t('pxtraCard:sumRecurring')}
        </Typography>
        <Typography variant="subtitle1" className="font-medium">
          {Util.formatCurrency(cost.recurring_monthly_cents)}
        </Typography>
      </Box>
      <Typography variant="caption" color="grey.600" className="flex-1">
        {t('pxtraCard:sumHint')}
      </Typography>
      <Box className="flex items-center gap-2">
        <Button
          variant="secondary"
          size="small"
          color="error"
          className="text-sm font-normal"
          onClick={onReject}
        >
          {t('pxtraCard:reject')}
        </Button>
        <Button
          size="small"
          className="text-sm font-normal"
          disabled={!canApprove}
          onClick={onApprove}
        >
          {t('pxtraCard:approveSelected', { count: selected.length })}
        </Button>
      </Box>
    </Box>
  );
};
